<div class="container">
    <div class="row">
        <div class="col-12 mb-5">
            <app-toolkit-page-title title="Approva utente"></app-toolkit-page-title>
            <div class="card">
                <div class="card-body">
                    <h6 id="table_description" class="sr-only">Risultati ricerca</h6>
                    <div style="transform: rotateX(180deg);" class="table-responsive mb-3">
                        <table style="transform: rotateX(180deg);" class="table table-striped table-sm" aria-describedby="table_description">
                            <thead class="thead-light">
                                <tr>
                                    <th scope="col">ID</th>
                                    <th scope="col">Cognome</th>
                                    <th scope="col">Nome</th>
                                    <th scope="col">Codice fiscale</th>
                                    <th scope="col">Email</th>
                                    <th scope="col">ENTE</th>
                                    <th scope="col">Ruolo</th>
                                    <th scope="col"></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of tableData">
                                    <td>{{ item.id }}</td>
                                    <td>{{ item.cognome }}</td>
                                    <td>{{ item.nome }}</td>
                                    <td>{{ item.codiceFiscale }}</td>
                                    <td>{{ item.email }}</td>
                                    <td>{{ item.ente | anagraficaEnte: (datalist.ente || []) }}</td>
                                    <td>{{ item.ruolo | anagraficaRuolo: (datalist.ruolo || []) }}</td>
                                    <td class="actions">
                                        <button aria-label="Approva utente" type="button" container="body" (click)="validazione('approva', item.id)" class="btn btn-xs btn-link" ngbTooltip="Approva utente">
                                            <app-toolkit-bl-icon icon="check-circle" cssClass="icon icon-sm icon-primary"></app-toolkit-bl-icon>
                                        </button>
                                        <button aria-label="Rifiuta utente" type="button" container="body" (click)="validazione('rifiuta', item.id)" class="btn btn-xs btn-link" ngbTooltip="Rifiuta utente">
                                            <app-toolkit-bl-icon icon="error" cssClass="icon icon-sm icon-danger"></app-toolkit-bl-icon>
                                        </button>
                                    </td>
                                </tr>
                                <tr *ngIf="!tableData.length">
                                    <td colspan="8"><p class="mb-0 text-center">Nessun risultato trovato.</p></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <ngb-pagination
                        *ngIf="tableData.length"
                        [(page)]="paginator.page"
                        [pageSize]="paginator.size"
                        [collectionSize]="paginator.total"
                        (pageChange)="onPageChange($event)"
                        ></ngb-pagination>
                </div>
            </div>
        </div>
    </div>
</div>